/**
 *
 * AmbassadorsImport
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Link } from "react-router-dom"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import ImportScreen from "components/ImportScreen"
import EmptyButton from "components/EmptyButton"
import { makeSelectIsDownloading, makeSelectIsUploading } from "./selectors"
import { getTemplate, uploadTemplate } from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import importSvg from "../../images/emptyAmbassadorsImport.svg"
import { LeftOutlined } from "@ant-design/icons"

/* eslint-disable react/prefer-stateless-function */
export class AmbassadorsImport extends React.Component {
  state = {}

  fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])

    this.props.uploadTemplate(fd)
    this.fileInput.value = ""
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Embajadores - Importación</title>
          <meta name="description" content="Description of Import" />
        </Helmet>
        <div style={{ padding: "32px 64px" }}>
          <Link
            style={{
              display: "flex",
              alignItems: "center",
            }}
            to="/control-panel#user-management">
            <LeftOutlined /> Gestión de usuarios
          </Link>
        </div>
        <ImportScreen
          image={importSvg}
          title="Importación de embajadores"
          secondPoint="Llena los campos con la información de los embajadores."
          thirdPoint="Importa el Excel con la información respectiva."
          description={`
            Asigna a los embajadores de las distintas divisiones introduciendo
            su <span>correo electrónico</span> y la <span>división</span> de la <br />
            que estarán a cargo en el documento de Excel. Los usuarios asignados podrán ejecutar planes  <br />
            de acción con el objetivo de mejorar el <span>Clima Laboral</span> y <span>Engagement</span>
            de su división.
          `}>
          <EmptyButton
            size="large"
            label="Descargar plantilla"
            loading={this.props.isDownloading}
            onClick={() => this.props.getTemplate(true)}
          />
          <EmptyButton
            size="large"
            onClick={() => this.fileInput.click()}
            loading={this.props.isUploading}
            label="Importar embajadores"
            style={{ marginLeft: "2rem" }}
          />
          <input
            style={{ display: "none" }}
            type="file"
            onChange={this.fileSelectedHandler}
            ref={(fileInput) => (this.fileInput = fileInput)}
          />
        </ImportScreen>
      </React.Fragment>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isDownloading: makeSelectIsDownloading(),
  isUploading: makeSelectIsUploading(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplate: (params) => dispatch(getTemplate(params)),
    uploadTemplate: (params) => dispatch(uploadTemplate(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "ambassadorsImport", reducer })
const withSaga = injectSaga({ key: "ambassadorsImport", saga })

export default compose(withReducer, withSaga, withConnect)(AmbassadorsImport)
